var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xm-echarts-line"},[(!_vm.noData)?_c('div',{ref:"statistEcharts",staticClass:"echartsLine",style:({ height: _vm.echartsHeight })}):_vm._e(),_vm._v(" "),(_vm.noData)?_c('div',{staticClass:"no-data"},[_vm._v("暂无数据")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }